
<!--
@author Stephen_zhou
@version
@return
 -->
<template>
  <div>
    <el-table
      size="medium"
      :data="tableData"
      :stripe="stripe"
      :border="false"
      :fit="true"
      :height="height"
      :show-header="true"
      :highlight-current-row="true"
      v-loading="columObj.loading"
      :row-class-name="tableRowClassName"
      @selection-change="handleSelectionChange"
      @row-click="rowClick">
      <!-- 选择框是否开启，selectable控制是否单行禁用 -->
      <el-table-column v-if="columObj.selection" type="selection" :selectable="columObj.selectable" width="50px"/>
      <!-- 普通列 -->
      <el-table-column v-for="(column,columIndex) in columObj.columnData" :key="columIndex" :prop="column.prop"
       :label="column.label" :width="column.width" :fixed="column.fixed" :align="column.align || 'center'"
       :sortable="column.sortable" :index="columIndex" show-overflow-tooltip>
        <template slot-scope="{row,$index}">
          <span v-if="column.text && column.editRow != $index && column.prop === 'index'" class="default-text">{{ $index + 1 }}</span>
          <!-- 默认展示 -->
          <span v-if="column.text && column.editRow != $index && column.prop !== 'index'"  class="default-text">{{row[column.prop] ? row[column.prop] : '--'}}</span>
          <!-- 状态对象展示 -->
          <span v-if="column.status && row[column.prop]">{{row[column.prop].msg}}</span>
          <!-- 自定义内容 -->
          <span v-if="column.ownDefined" class="default-text">{{column.ownDefinedReturn(row,$index)}}</span>
          <!-- switch开关 -->
          <el-switch v-if="column.switch" v-model="row[column.prop]" :inactive-text="row[column.prop] ? column.openText:column.closeText" @change="switchChange(row,$index,column.prop)"/>
          <!-- 图片展示 -->
          <el-popover trigger="hover" placement="top" popper-class="popper">
            <img v-if="column.image" :src="viewUrl + row[column.prop]" />
            <el-image slot="reference" v-if="column.image" :src="viewUrl + row[column.prop]"/>
          </el-popover>

          <!-- 图片数组 -->
          <el-popover v-if="column.imageArr" trigger="hover" placement="top" popper-class="popper">
            <img v-if="row[column.prop].length>0" :src="row[column.prop][0]" />
            <el-image slot="reference" v-if="row[column.prop].length >0" :src="row[column.prop][0]" :preview-src-list="row[column.prop]"/>
          </el-popover>

          <!-- 可编辑input，仅在text默认展示类型才可编辑-->
          <el-input v-focus v-if="column.editRow == $index" v-model="row[column.prop]" @blur="editInputBlur(row,$index,column.prop,columIndex)"/>
          <!-- 操作按钮 -->
          <span v-if="column.isOperation" v-for="(operations, index) in column.operation" :key="index">
						<el-button v-if="operations.isShow(row,$index)" :icon="operations.icon" :type="operations.type" @click="operations.buttonClick(row, $index, operations.action)" :style="{color:operations.color}" size="small">{{operations.label}}</el-button>
					</span>
        </template>
      </el-table-column>
      <div slot="empty" class="empty">
        <el-empty :description="$t('table.noData')" :image-size="100"/>
      </div>
    </el-table>
    <!-- 分页 -->
    <div class="page_div" :style="{textAlign: pageObj.position || 'center'}">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
       :hide-on-single-page="false" :current-page="pageObj.pageData.current" :pager-count="7"
       :page-sizes="[10, 15, 20, 30,50]" :page-size="pageObj.pageData.size" background
       layout="total,sizes,prev, pager, next" :total="pageObj.pageData.total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  directives: {
    // 自定义指令,用于可编辑input自动获取焦点
    focus: {
      inserted: function(e) {
        e.querySelector('input').focus()
      }
    }
  },
  props: {
    tableData: {
      type: Array,
      required: true,
    },
    columObj: {
      type: Object,
      required: true
    },
    pageObj: {
      type: Object,
      required: true
    },
    stripe: {
      type: Boolean,
    },
    height: {
      type: String,
    }
  },
  data() {
    let readUploadFileUrl = this.$store.state.user.readUploadFileUrl;
    return {
      viewUrl: readUploadFileUrl,
    }
  },
  methods: {
    // switchChange调用
    switchChange(row, $index, prop) {
      this.$emit("switchChange", row, $index, prop);
    },
    // 帮助点击行，获取点击的下标
    tableRowClassName({row, rowIndex}) {
      row.rowIndex = rowIndex;
    },
    // 点击行
    rowClick(row, column, event) {
      this.$emit("rowClick", row, column, event);
    },
    // 可编辑input失去焦点
    editInputBlur(row, $index, prop, columIndex) {
      this.$emit('editInputBlur', row, $index, prop, columIndex);
    },
    // 条数变化
    handleSizeChange(e) {
      this.$emit('handleSizeChange', e);
    },
    // 页码变化
    handleCurrentChange(e) {
      this.$emit('handleCurrentChange', e);
    },
    // 行选择
    handleSelectionChange(val) {
      this.$emit('handleSelectionChange', val)
    }
  }
}
</script>
<style lang="scss" scoped>
.el-button {
  margin: 0 6px;
}

.empty {
  display: flex;
  justify-content: center;
}

.default-text {
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #333333;
}

::v-deep .el-input__inner {
  border: none;
}

::v-deep .el-image__inner {
  height: 50px;
}

// switch左边文字颜色
::v-deep .el-switch__label--left {
  color: #606266;
}

img {
  height: 400px;
}

.page_div {
  padding: 15px 0;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #01AAA7;
}
</style>
